<div class="submenu-mobile">
    <div class="menu-columna" *ngFor="let categoria of modelos | keyvalue; let last = last; let i = index"  [id]="categoria.key">
        <div class="menu-opciones-categoria">
            <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">{{ formatKey(categoria.key) }}</h3>
            <ul>
              <li *ngFor="let modelo of categoria.value" class="menu-opciones-categoria-items my-3">
                <a [routerLink]="[categoria.key, modelo.modelo_url]" class="text-uppercase ff-medium fs-6" (click)="cerrarMenu()">{{ modelo.nombre_modelo }}</a>
              </li>
            </ul>
        </div>
    </div>
</div>
